import SideTool from "@/global/components/side-tool";

export default function MonitoringParams() {
    
    return(
        <div>
            <SideTool />
            monitoring-params
        </div>
    )
}